import { __ } from '@wordpress/i18n';
import { PanelBody, ToggleControl, SelectControl } from '@wordpress/components';

// Translated at module load; WP loads i18n catalog before block scripts.
const CAPTION_OPTIONS = [
  { label: __('Item title', 'brandy-blocks'), value: 'title' },
  { label: __('Item description', 'brandy-blocks'), value: 'description' },
  { label: __('Image alt text', 'brandy-blocks'), value: 'imageAlt' },
  { label: __('None', 'brandy-blocks'), value: 'none' },
];

export default function LightboxPanel({ attributes, setAttributes }) {
  const { enableLightbox, captionSource, showCounter, loop } = attributes;
  return (
    <PanelBody title={__('Lightbox', 'brandy-blocks')} initialOpen={false}>
      <ToggleControl
        label={__('Enable lightbox', 'brandy-blocks')}
        help={__(
          'When enabled, clicking an item opens a full-screen viewer with prev/next navigation.',
          'brandy-blocks'
        )}
        checked={enableLightbox}
        onChange={(value) => setAttributes({ enableLightbox: value })}
      />
      {enableLightbox && (
        <>
          <SelectControl
            label={__('Caption source', 'brandy-blocks')}
            value={captionSource}
            options={CAPTION_OPTIONS}
            onChange={(value) => setAttributes({ captionSource: value })}
          />
          <ToggleControl
            label={__('Show counter', 'brandy-blocks')}
            checked={showCounter}
            onChange={(value) => setAttributes({ showCounter: value })}
          />
          <ToggleControl
            label={__('Loop navigation', 'brandy-blocks')}
            checked={loop}
            onChange={(value) => setAttributes({ loop: value })}
          />
        </>
      )}
    </PanelBody>
  );
}
